import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GreenBoxLogo from "../assets/Greenbox.png";

const CompanyLogo: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();

  if (location.pathname.includes("/admin")) {
    return null;
  }

  return (
    <button
      onClick={() => navigate(`/${lang}`)}
      className="w-[200px] h-[150px] absolute top-4 left-4 p-4 rounded-3xl border shadow-md flex justify-center items-center bg-white hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-shadow"
      aria-label="Go to homepage"
    >
      <img
        src={GreenBoxLogo}
        alt="Greenbox mobile energy logo"
        className="max-w-full h-auto"
        loading="eager"
        width="160"
        height="120"
      />
    </button>
  );
};

export default CompanyLogo;
